import Vue from "vue";
import Vuex from "vuex";

import InfoRequestStore from "@Scripts/Stores/InfoRequestStore";
import CartStore from "@Scripts/Stores/CartStore";
import NewsletterStore from "@Scripts/Stores/NewsletterStore";

Vue.use(Vuex);

export const store = new Vuex.Store({});

store.registerModule("infoRequestStore", InfoRequestStore);
store.registerModule("cartStore", CartStore);
store.registerModule("newsletterStore", NewsletterStore);